import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import HotRecommendSection from "./components/HotRecommendSection";
import LatestSection from "./components/LatestSection";
import FeatureSection from "./components/FeatureSection";
import CtaSection from "./components/CtaSection";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "丁香花影院",
  url: "https://www.lilaccinema.com",
  description: "丁香花影院作为稳定在线影院，提供网络电视、电影网站级视频点播服务，追剧平台免费看高清电影电视剧，无需缓冲。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.lilaccinema.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "丁香花影院",
  url: "https://www.lilaccinema.com",
  description: "丁香花影院是国内领先的在线视频点播平台，提供海量高清电影电视剧免费在线观看服务。",
  contactPoint: {
    "@type": "ContactPoint",
    email: "contact@lilaccinema.com",
    contactType: "customer service",
    availableLanguage: ["Chinese"],
  },
};

export default function Home() {
  return (
    <>
      <Seo
        title="丁香花影院 - 在线影院免费观看高清电影 | 追剧平台最新电视剧全集"
        description="丁香花影院作为稳定在线影院，提供网络电视、电影网站级视频点播服务，追剧平台免费看高清电影电视剧，无需缓冲。涵盖动作片、喜剧片、科幻片、爱情片等多种类型，海量资源每日更新。"
        keywords="丁香花影院,在线影院,网络电视,电影网站,视频点播,追剧平台,在线观看,免费电影,电视剧全集,高清"
        canonicalUrl="https://www.lilaccinema.com"
        ogImage="https://readdy.ai/api/search-image?query=Luxurious%20cinema%20interior%20with%20warm%20golden%20lighting%2C%20velvet%20red%20theater%20curtains%2C%20elegant%20movie%20theater%20atmosphere%2C%20cinematic%20style%2C%20warm%20tones&width=1200&height=630&seq=og-home&orientation=landscape"
        schemaJson={{ ...homeSchema, ...orgSchema }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />
            <CategorySection />
            <HotRecommendSection />
            <LatestSection />
            <FeatureSection />
            <CtaSection />
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}